import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Text = styled.span`
  font-family: 'SBAggroB', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
  position: relative;
  top: 2px;
`;

const BetaTag = styled.span`
  display: flex;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${(props) => props.theme.global.mainColor2};
  color: ${(props) => props.theme.global.whiteTextColor};
`;

const Icon = () => {
  return (
    <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7294 8.46548L0.177224 11.4989C0.0894056 11.5238 0.00158691 11.4588 0.00158691 11.3689V0.216915C0.00158691 0.142255 0.0629206 0.0814209 0.139588 0.0814209H10.2708C12.161 0.0814209 13.6943 1.60089 13.6943 3.47708V4.55412C13.6943 6.3667 12.4858 7.96222 10.7308 8.46686L10.7294 8.46548Z"
        fill="#5352ED"
      />
      <path
        d="M13.5547 27.4987H0.136607C0.0613337 27.4987 0 27.4379 0 27.3632V14.7124C0 14.6516 0.0404245 14.5991 0.0989703 14.5825L8.97702 12.0219C11.6353 11.22 13.7401 12.5929 13.6914 15.1922V27.3618C13.6914 27.4365 13.63 27.4973 13.5547 27.4973V27.4987Z"
        fill="#5352ED"
      />
      <path
        d="M26.5779 0H16.4467C16.3714 0 16.3101 0.0608342 16.3101 0.135494V27.2814C16.3101 27.356 16.3714 27.4169 16.4467 27.4169H21.8203C21.8956 27.4169 21.9569 27.356 21.9569 27.2814V8.7463C21.9569 8.68961 21.9932 8.63846 22.0475 8.6191L23.6785 8.0315C24.006 7.91259 24.3531 8.15455 24.3531 8.5002V27.2814C24.3531 27.356 24.4145 27.4169 24.4897 27.4169H29.8634C29.9387 27.4169 30 27.356 30 27.2814V3.39565C30 1.52086 28.4681 0 26.5765 0H26.5779Z"
        fill="#5352ED"
      />
    </svg>
  );
};

interface LogoProps {
  hasBetaTag?: boolean;
}

const Logo = ({ hasBetaTag }: LogoProps) => {
  return (
    <Container>
      <Icon />
      <Text>{`BlockAI`}</Text>
      {hasBetaTag && <BetaTag>BETA</BetaTag>}
    </Container>
  );
};

export default Logo;
